import { alpha, Box, styled } from "@mui/material";
import { colors, transitions } from "../../styles/theme";

export const PeekChildrenCollapsed = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  cursor: "pointer",
  // marginBottom: "-1px",
  transition: transitions.join(["height"], transitions.linear),
  position: "relative",
  "&::after": {
    content: "''",
    position: "absolute",
    left: 0,
    right: 0,
    width: "100%",
    height: "1px",
    background: `linear-gradient(
      to right,
      ${alpha(colors.text.v1, 1)} 0%,
      ${alpha(colors.text.v1, .2)} 30%,
      ${alpha(colors.text.v1, 0)} 50%,
      ${alpha(colors.text.v1, .2)} 70%,
      ${alpha(colors.text.v1, 1)} 100%
    )`,
    zIndex: 2
  }
}));

